import { render, staticRenderFns } from "./AiActionCard.vue?vue&type=template&id=c086c37e&scoped=true"
import script from "./AiActionCard.vue?vue&type=script&lang=js"
export * from "./AiActionCard.vue?vue&type=script&lang=js"
import style0 from "./AiActionCard.vue?vue&type=style&index=0&id=c086c37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c086c37e",
  null
  
)

export default component.exports